import { Box, CircularProgress } from '@mui/material';
import { HashRouter, Route, Switch } from 'react-router-dom';
import AnnotationEvents from './components/AnnotationEvents';
import AnomalyComponent from './components/Anomaly';
import Dashboard from './components/Dashboard';
import Devices from './components/Devices';
import Event from './components/Event';
import Live from './components/Live';
import Login from './components/Login';
import NotificationComponent from './components/Notification';
import Analysis from './components/Analysis';
import ScrollToTop from './components/ScrollTop';
import { UserContext } from './components/UserContext';
import DeviceDetail from './components/DeviceDetail';
import OrgAdmin from './components/OrgAdmin';
import UserPreferences from './components/UserPreferences';

function Routes() {
  return (
    <HashRouter>
      <ScrollToTop>
        <UserContext.Consumer>
          {(context) => {
            // Show loading spinner while authentication status is being determined
            if (!context.loaded) {
              return (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                  <CircularProgress />
                </Box>
              );
            }

            const routes = context.profile ? (
              <Switch>
                <Route exact path="/" component={Dashboard} />
                <Route exact path="/annotations" component={AnnotationEvents} />
                <Route exact path="/annotations/event" component={Event} />
                <Route exact path="/analysis" component={Analysis} />
                <Route
                  exact
                  path="/notification"
                  component={NotificationComponent}
                />
                <Route
                  exact
                  path="/notification/anomaly"
                  component={AnomalyComponent}
                />
                <Route exact path="/live" component={Live} />
                <Route path="/devices/:deviceId" component={DeviceDetail} />
                <Route exact path="/devices" component={Devices} />
                <Route exact path="/admin" component={OrgAdmin} />
                <Route exact path="/preferences" component={UserPreferences} />
                <Route exact path="/login" component={Login} />
              </Switch>
            ) : (
              <Route component={Login} />
            );
            return routes;
          }}
        </UserContext.Consumer>
      </ScrollToTop>
    </HashRouter>
  );
}

export default Routes;
